<template>
  <section>
    <SharedPageHeaderTitle :title="t('pages.features.onlineRecord.headerTitle')" />

    <div class="base-container-first records__wrapper">
      <SharedPageSectionCard :card="SECTION_CARD" />

      <ul class="records__cards three-cards">
        <li
          v-for="(card, cardIndex) in CARDS"
          :key="cardIndex"
        >
          <SharedPageCard
            isWhite
            :card
          />
        </li>
      </ul>

      <SharedPageBusiness :business-list="BUSINESSES" />

      <ul class="records__cards">
        <li
          v-for="(setting, settingIndex) in SETTINGS"
          :key="settingIndex"
        >
          <SharedPageCard
            isWhite
            :card="setting"
          />
        </li>
      </ul>
    </div>
  </section>

  <ContactOrderForm
    :description="t('pages.features.onlineRecord.managerDescription')"
    :title="t('pages.features.onlineRecord.questionsTitle')"
  />
</template>

<script setup lang="ts">
const { t, locale } = useI18n();

const CARDS = computed(() => [
  {
    description: t("pages.features.onlineRecord.cards.appointmentJournal.description"),
    image: "records-card-1",
    title: t("pages.features.onlineRecord.cards.appointmentJournal.title"),
  },
  {
    description: t("pages.features.onlineRecord.cards.workSchedule.description"),
    image: "records-card-2",
    title: t("pages.features.onlineRecord.cards.workSchedule.title"),
  },
  {
    description: t("pages.features.onlineRecord.cards.appointmentTypes.description"),
    image: "records-card-3",
    title: t("pages.features.onlineRecord.cards.appointmentTypes.title"),
  },
]);

const SECTION_CARD = {
  description: t("pages.features.onlineRecord.sectionCard.description"),
  href: "https://t.me/DalyCityBot",
  image: "records-section-card",
  title: t("pages.features.onlineRecord.sectionCard.title"),
};

const BUSINESSES = computed(() => [
  t("pages.features.onlineRecord.businesses.beautySalon"),
  t("pages.features.onlineRecord.businesses.tutor"),
  t("pages.features.onlineRecord.businesses.photoStudio"),
  t("pages.features.onlineRecord.businesses.restaurant"),
  t("pages.features.onlineRecord.businesses.yourBusiness"),
]);

const SETTINGS = computed(() => [
  {
    description: t("pages.features.onlineRecord.cards.versatility.description"),
    image: "records-card-4",
    title: t("pages.features.onlineRecord.cards.versatility.title"),
  },
  {
    description: t("pages.features.onlineRecord.cards.clientNotifications.description"),
    image: "records-card-5",
    title: t("pages.features.onlineRecord.cards.clientNotifications.title"),
  },
]);

useSeoMeta({
  title: t("pages.features.onlineRecord.seo.title"),
});
</script>

<style scoped>
.records__wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 80px;
  margin: 0 auto 80px;
  padding: 0 24px;
}

@media (--desktop) {
  .records__wrapper {
    row-gap: 120px;
    margin-bottom: 120px;
  }
}

.records__cards {
  display: grid;
  row-gap: 16px;
}

@media (--desktop) {
  .records__cards {
    grid-template-columns: repeat(2, 1fr);
    column-gap: 20px;
  }
}

@media (--desktop) {
  .records__cards.three-cards {
    grid-template-columns: repeat(3, 1fr);
  }
}
</style>
